import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { StationLongDto } from '@api/rest';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-detail',
  imports: [MatIcon, TranslatePipe],
  templateUrl: './contact-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-detail.component.scss',
})
export class ContactDetailComponent {
  protected readonly translate = inject(TranslateService);
  protected readonly contact = input<StationLongDto | undefined>(undefined);
}
